import React from "react";
import styles from "./MMScreenInputViews.module.css";
import Vector from "../../../../../assets/images/Vector.svg";
import { TableHead, TableRow } from "@mui/material";
import { StyledTableCell } from "./styledComponent";
// const specialColumns = ["Overall RMPM coverage %", "Physical RMPM coverage %"];

const TblHeader = ({ columns, requestSort, sortConfig, isActionable = false }) => {
    // const { requestSort } = useDailyPhasingContext();
    return (
        <TableHead sx={{ position: 'sticky', top: 0, zIndex: 999 }}>
            {columns?.length > 0 ? (
                <TableRow sx={{ backgroundColor: "var(--primany-table-header-color)" }}>
                    {isActionable && <StyledTableCell></StyledTableCell>}
                    {columns
                        .filter((column) => column.visibility)
                        .map((column, index) => (
                            <StyledTableCell
                                key={`TblHead${index}`}
                                sx={{
                                    cursor: column.sortable ? "pointer" : "default",
                                }}
                                onClick={() => column.sortable && requestSort(column.label)}
                            >
                                <div className={styles.cellWrapper}>
                                    <span className={styles.cellText}>
                                        {column.label}
                                    </span>
                                    {column.sortable && sortConfig.key === column.label && column.label !== "Total" && (
                                        <img 
                                            src={Vector} 
                                            alt="sort icon" 
                                            width="14px" 
                                            height="14px" 
                                            className={styles.sortIconImg} 
                                        />
                                    )}
                                </div>
                            </StyledTableCell>
                        ))
                    }
                    {isActionable && (
                        <StyledTableCell
                            sx={{ backgroundColor: "var(--primany-table-header-color)" }}
                            colSpan={2}
                        >
                            Action
                        </StyledTableCell>
                    )}
                </TableRow>
            ) : (
                <TableRow>
                    <StyledTableCell sx={{ backgroundColor: "var(--primany-table-header-color)" }}>
                        No columns available...
                    </StyledTableCell>
                </TableRow>
            )}
        </TableHead>
    );
};

export default React.memo(TblHeader);
